(function(){
  var Q=String.fromCharCode(34); // inch mark
  var DASH=String.fromCharCode(8211); // en dash for open accordions

  function init(root){
    var cfgEl=root.querySelector('script[data-utv-cfg]');
    if(!cfgEl){return;}
    var cfg={};
    try{cfg=JSON.parse(cfgEl.textContent);}catch(e){return;}
    var V=cfg.variants||[];
    if(!V.length){return;}
    var WHEELS=cfg.wheels||[];
    var TREADS=cfg.treads||[];
    var M=cfg.machine||{};
    var NOTES=M.size_notes||{};
    var LUGS=M.lugs||[];
    var PIMG=cfg.product_img||'';

    var presentW={},presentT={};
    V.forEach(function(v){presentW[v.option1]=true;presentT[v.option3]=true;});
    var wheels=WHEELS.filter(function(w){return presentW[w.value];});
    var treads=TREADS.filter(function(t){return presentT[t.value];});
    if(!wheels.length||!treads.length){return;}
    var DIAS=[];
    wheels.forEach(function(w){if(DIAS.indexOf(w.dia)<0){DIAS.push(w.dia);}});
    DIAS.sort();
    var SIZES=[];
    V.forEach(function(v){if(SIZES.indexOf(v.option2)<0){SIZES.push(v.option2);}});
    SIZES.sort(function(a,b){return parseFloat(a)-parseFloat(b);});

    function q(s){return root.querySelector(s);}
    function qa(s){return root.querySelectorAll(s);}
    function wname(w){return w.brand+(w.model?' '+w.model:'');}
    function variantFor(w,s,t){for(var i=0;i<V.length;i++){if(V[i].option1===w&&V[i].option2===s&&V[i].option3===t){return V[i];}}return null;}
    function W(){for(var i=0;i<wheels.length;i++){if(wheels[i].value===st.wheel){return wheels[i];}}return wheels[0];}
    function T(){for(var i=0;i<treads.length;i++){if(treads[i].value===st.tread){return treads[i];}}return treads[0];}
    function availSizes(w,t){return SIZES.filter(function(s){return variantFor(w,s,t);});}
    function money(c){return '$'+Number(c/100).toLocaleString(undefined,{minimumFractionDigits:0,maximumFractionDigits:2});}
    function tireSize(t,w){var tw=(t.width||'10');var sep=(t.construction==='Bias'?'-':'R');return st.size+'x'+tw+sep+w.dia;}
    function tireSku(t,w){return (t.skus&&t.skus[st.size+'-'+w.dia])?t.skus[st.size+'-'+w.dia]:'';}

    var firstW=wheels.filter(function(w){return w.dia===DIAS[0];})[0];
    var st={tread:treads[0].value,dia:DIAS[0],wheel:firstW.value,size:SIZES[0],lugVar:null,lugPrice:0,view:(PIMG?'product':'wheel')};
    var av0=availSizes(st.wheel,st.tread);
    if(av0.indexOf(st.size)<0){st.size=av0[0];}

    function renderTreads(){
      q('[data-treads]').innerHTML=treads.map(function(t){
        return '<button type="button" class="u-tread'+(t.value===st.tread?' u-sel':'')+'" data-tread="'+encodeURIComponent(t.value)+'">'+
          '<span class="u-trimg"><img src="'+t.img+'" alt="'+t.name+'"></span>'+
          '<span><span class="u-trt">'+t.terrain+'</span><span class="u-trn">'+t.name+'</span><span class="u-trd">'+t.desc+'</span></span></button>';
      }).join('');
      qa('[data-treads] .u-tread').forEach(function(b){b.addEventListener('click',function(){st.tread=decodeURIComponent(b.getAttribute('data-tread'));st.view='tire';update();});});
    }
    function renderDia(){
      q('[data-diaseg]').innerHTML=DIAS.map(function(d){return '<button type="button" class="'+(d===st.dia?'u-sel':'')+'" data-dia="'+d+'">'+d+'&quot;</button>';}).join('');
      qa('[data-diaseg] button').forEach(function(b){b.addEventListener('click',function(){var d=b.getAttribute('data-dia');if(d===st.dia){return;}st.dia=d;var f=wheels.filter(function(w){return w.dia===d;})[0];if(f){st.wheel=f.value;}st.view='wheel';update();});});
    }
    function renderWheels(){
      var list=wheels.filter(function(w){return w.dia===st.dia;});
      q('[data-wheels]').innerHTML=list.map(function(w){
        return '<div class="u-wheel'+(w.value===st.wheel?' u-sel':'')+'" data-id="'+encodeURIComponent(w.value)+'">'+
          '<div class="u-wd">'+w.dia+'&quot;</div>'+
          '<div class="u-wimg"><img src="'+w.img+'" alt="'+wname(w)+'"></div>'+
          '<div class="u-wb">'+wname(w)+'</div><div class="u-wf">'+w.fin+' &middot; '+w.offset+'</div></div>';
      }).join('');
      qa('.u-wheel').forEach(function(el){el.addEventListener('click',function(){st.wheel=decodeURIComponent(el.getAttribute('data-id'));st.view='wheel';update();});});
    }
    function reason(){return 'Not available with this wheel and tread';}
    function renderSizes(){
      var av=availSizes(st.wheel,st.tread);
      q('[data-seg]').innerHTML=SIZES.map(function(s){
        var ok=av.indexOf(s)>-1;
        return '<button type="button" class="'+(s===st.size?'u-sel':'')+(ok?'':' u-dis')+'" data-size="'+s+'"'+(ok?'':' disabled title="'+reason()+'"')+'>'+s+'&quot;</button>';
      }).join('');
      qa('[data-seg] button').forEach(function(b){if(!b.disabled){b.addEventListener('click',function(){st.size=b.getAttribute('data-size');update();});}});
    }
    function renderLugs(){
      var el=q('[data-lugseg]');if(!el){return;}
      var html='<button type="button" class="'+(st.lugVar?'':'u-sel')+'" data-lug="">None</button>';
      LUGS.forEach(function(L){
        html+='<button type="button" class="'+(st.lugVar===L.variant_id?'u-sel':'')+'" data-lug="'+L.variant_id+'" data-lp="'+L.price+'">'+L.finish+' +$'+L.price+'</button>';
      });
      el.innerHTML=html;
      qa('[data-lugseg] button').forEach(function(b){b.addEventListener('click',function(){var id=b.getAttribute('data-lug');st.lugVar=id?id:null;st.lugPrice=id?parseFloat(b.getAttribute('data-lp')||0):0;update();});});
    }
    function setMain(){
      var m=q('[data-main]');if(!m){return;}
      if(st.view==='product'&&PIMG){m.src=PIMG;m.alt='';return;}
      if(st.view==='tire'){var t=T();m.src=t.img;m.alt=t.name;return;}
      var w=W();m.src=w.img;m.alt=wname(w);
    }

    function update(){
      var inDia=wheels.filter(function(w){return w.dia===st.dia;});
      if(inDia.length&&!inDia.some(function(w){return w.value===st.wheel;})){st.wheel=inDia[0].value;}
      var w=W(),t=T();
      var av=availSizes(st.wheel,st.tread);
      if(av.indexOf(st.size)<0){st.size=av[0];}
      var v=variantFor(st.wheel,st.size,st.tread);
      var fullsize=tireSize(t,w);

      var bt=q('[data-bterr]');if(bt){bt.textContent=t.terrain;}
      var thw=q('[data-thwheel]');if(thw){thw.src=w.img;}
      var tht=q('[data-thtire]');if(tht){tht.src=t.img;tht.alt=t.name;}
      q('[data-cap]').textContent='Shown: '+wname(w)+' '+w.dia+Q+' '+w.fin+' with '+t.name;
      q('[data-incwheel]').textContent=wname(w)+' '+w.fin+' wheels ('+w.wsize+')';
      q('[data-inctire]').textContent=t.name+' tires ('+fullsize+')';
      q('[data-spectirebrand]').textContent=t.brand;
      q('[data-spectiremodel]').textContent=t.model;
      q('[data-specsize]').textContent=fullsize;
      q('[data-specply]').textContent=t.ply;
      q('[data-specconstruction]').textContent=t.construction;
      q('[data-specwheelbrand]').textContent=w.brand;
      q('[data-specwheelmodel]').textContent=w.model;
      q('[data-specwsize]').textContent=w.wsize;
      q('[data-specoffset]').textContent=w.offset;
      q('[data-specfin]').textContent=w.fin;

      var lugCents=Math.round((st.lugPrice||0)*100);
      var pe=q('[data-uprice]');if(pe){pe.textContent=money((v?v.price:0)+lugCents);}
      var idin=q('[data-uvid]');if(idin&&v){idin.value=v.id;}

      var gn=q('[data-greynote]');
      if(gn){gn.textContent=M.size_help||'';}
      var sn=q('[data-sizenote]');
      if(sn){
        var note=NOTES[st.size];
        if(note&&note.text){
          sn.style.display='';
          sn.className='u-sizenote'+(note.level==='warn'?' u-warn':'');
          sn.innerHTML='<span class="u-dot">'+(note.level==='warn'?'!':'&#10003;')+'</span><span>'+note.text+'</span>';
        }else{sn.style.display='none';sn.innerHTML='';}
      }
      renderTreads();renderDia();renderWheels();renderSizes();renderLugs();setMain();
    }

    qa('.u-thumb').forEach(function(th){th.addEventListener('click',function(){qa('.u-thumb').forEach(function(x){x.classList.remove('u-active');});th.classList.add('u-active');st.view=th.getAttribute('data-view');setMain();});});
    qa('[data-sec]').forEach(function(sec){var h=sec.querySelector('.u-sec-h');if(h){h.addEventListener('click',function(){sec.classList.toggle('u-open');var pm=sec.querySelector('.u-pm');if(pm){pm.textContent=sec.classList.contains('u-open')?DASH:'+';}});}});

    var form=root.querySelector('form');
    if(form){
      form.addEventListener('submit',function(e){
        e.preventDefault();e.stopPropagation();
        if(e.stopImmediatePropagation){e.stopImmediatePropagation();}
        var v=variantFor(st.wheel,st.size,st.tread);
        if(!v){return;}
        var w=W(),t=T();
        var props={};
        if(w.sku){props['_Wheel SKU']=w.sku;}
        var ts=tireSku(t,w);
        if(ts){props['_Tire SKU']=ts;}
        props['_Setup']=wname(w)+' '+w.wsize+' '+w.fin+' with '+tireSize(t,w)+' '+t.name;
        var items=[{id:Number(v.id),quantity:1,properties:props}];
        if(st.lugVar){items.push({id:Number(st.lugVar),quantity:1});}
        var btn=form.querySelector('.u-cta');
        if(btn){btn.disabled=true;btn.textContent='Adding to cart';}
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
          .then(function(r){return r.json();})
          .then(function(){window.location.href='/cart';})
          .catch(function(){if(btn){btn.disabled=false;btn.textContent='Add package to cart';}});
      },true);
    }

    update();
  }

  function boot(){var roots=document.querySelectorAll('.utvpkg');for(var i=0;i<roots.length;i++){init(roots[i]);}}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}else{boot();}
})();